<template>
  <div class="sidebar-container" :class="{ 'collapsed': isCollapse }">
    <!-- 侧边栏头部 -->
    <div class="sidebar-header">
      <h3 class="sidebar-title">管理系统</h3>
      <el-button v-if="isMobile" type="text" icon="el-icon-close" @click="toggleSidebar" class="close-btn"></el-button>
    </div>

    <!-- 侧边栏菜单 -->
       <el-menu :default-active="activeMenu" class="sidebar-menu" router @select="handleSelect" :collapse="isCollapse"
         :collapse-transition="false" unique-opened>
         <!-- 动态生成菜单 -->
         <template v-for="menu in menuList">
           <!-- 有子菜单的情况 -->
           <el-submenu v-if="menu.children && menu.children.length > 0" :index="menu.id.toString()" :key="menu.id">
             <template slot="title">
               <i v-if="menu.icon" :class="'el-icon-' + menu.icon"></i>
               <i v-else class="el-icon-menu"></i>
               <span>{{ menu.menu_name }}</span>
             </template>
             <el-menu-item
               v-for="childMenu in menu.children"
               :key="childMenu.id"
               :index="childMenu.route_url"
             >
               <i v-if="childMenu.icon" :class="'el-icon-' + childMenu.icon"></i>
               <i v-else class="el-icon-menu"></i>
               <span slot="title">{{ childMenu.menu_name }}</span>
             </el-menu-item>
           </el-submenu>
           <!-- 无子菜单的情况 -->
           <el-menu-item v-else :index="menu.route_url" :key="menu.id">
             <i v-if="menu.icon" :class="'el-icon-' + menu.icon"></i>
             <i v-else class="el-icon-menu"></i>
             <span slot="title">{{ menu.menu_name }}</span>
           </el-menu-item>
         </template>
       </el-menu>

    <!-- 折叠按钮 -->
    <div v-if="!isMobile" class="collapse-btn" @click="toggleCollapse">
      <i :class="isCollapse ? 'el-icon-s-unfold' : 'el-icon-s-fold'"></i>
    </div>
  </div>
</template>

<script>
import { getUserInfo } from '@/utils/auth'

export default {
  name: 'SidebarMenu',
  data() {
    return {
      isCollapse: false,
      isMobile: false,
      showSidebar: true, // 控制移动端侧边栏显示
      sidebarWidth: 260, // 侧边栏宽度
      sidebarCollapsedWidth: 64, // 侧边栏折叠宽度
      menuList: [] // 菜单列表
    }
  },
  computed: {
    activeMenu() {
      // 获取当前路由路径作为激活菜单
      const path = this.$route ? this.$route.path : ''
      return path || '/index'
    }
  },
     mounted() {
       // 检测是否为移动设备
       this.checkIsMobile()
       window.addEventListener('resize', this.checkIsMobile)
       // 获取用户信息并设置菜单列表
       this.fetchMenuList()
     },
     beforeDestroy() {
       window.removeEventListener('resize', this.checkIsMobile)
     },
     methods: {
       // 获取菜单列表
       fetchMenuList() {
         const userInfo = getUserInfo()
         if (userInfo && userInfo.menu_list) {
           this.menuList = userInfo.menu_list
           console.log('获取菜单列表成功:', this.menuList)
         } else {
           console.log('未获取到菜单列表，使用默认菜单')
           // 如果没有菜单列表，使用默认菜单
           this.menuList = [
             {
               "id": 5,
               "menu_name": "首页",
               "parent_id": 0,
               "sort": 1,
               "route_url": "/index",
               "component_path": null,
               "route_param": "",
               "route_name": "",
               "is_frame": 0,
               "type": 1,
               "is_show": 1,
               "perms": "/index",
               "icon": "s-home",
               "status": null,
               "created_at": "2026-02-05T01:18:54.000000Z",
               "updated_at": "2026-02-05T01:18:54.000000Z",
               "deleted_at": null,
               "children": []
             }
           ]
         }
       },
       
       // 检测是否为移动设备
       checkIsMobile() {
         this.isMobile = window.innerWidth <= 768
         if (this.isMobile) {
           this.isCollapse = false
           // 移动端默认隐藏侧边栏
           this.showSidebar = false
         } else {
           this.showSidebar = true
         }
       },

       // 切换折叠状态
       toggleCollapse() {
         this.isCollapse = !this.isCollapse
       },

       // 切换侧边栏显示（移动端）
       toggleSidebar() {
         this.showSidebar = !this.showSidebar
       },

       // 菜单选择处理
       handleSelect(key, keyPath) {
         console.log('选中菜单:', key, keyPath)
         // 移动端点击菜单后自动关闭侧边栏
         if (this.isMobile) {
           this.showSidebar = false
         }
       }
     }
}
</script>

<style scoped>
.sidebar-container {
  height: 100vh;
  width: 260px;
  background-image: linear-gradient(rgb(0, 21, 41), rgb(0, 21, 41));
  color: #fff;
  position: relative;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  overflow-y: auto;
  overflow-x: hidden;
  z-index: 100;
  box-shadow: 2px 0 8px rgba(0, 0, 0, 0.15);

}

.sidebar-container.collapsed {
  width: 64px;
}

/* 滚动条美化 */
.sidebar-container::-webkit-scrollbar {
  width: 6px;
  height: 0;
}

.sidebar-container::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.05);
}

.sidebar-container::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 3px;
}

.sidebar-container::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.3);
}

/* 侧边栏头部 */
.sidebar-header {
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 20px;
  background: rgba(255, 255, 255, 0.05);
  position: relative;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.sidebar-title {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: #fff;
  letter-spacing: 0.5px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.sidebar-container.collapsed .sidebar-title {
  display: none;
}

.close-btn {
  position: absolute;
  right: 10px;
  color: #fff;
  transition: color 0.3s;
}

.close-btn:hover {
  color: #409EFF;
}

/* 侧边栏菜单 - 深色主题，白色文字，激活态左侧高亮 */
.sidebar-menu {
  background-color: transparent;
  border-right: none;
}

/* 基础项样式 */
.sidebar-menu .el-menu-item,
.sidebar-menu .el-submenu__title {
  color: #ffffff;
  height: 52px;
  line-height: 52px;
  font-size: 14px;
  padding-left: 24px !important;
  transition: background 0.18s, color 0.18s;
  border-radius: 0 8px 8px 0;
  margin: 6px 6px;
  /* 让每项之间有些呼吸感 */
  position: relative;
  /* 为激活态伪元素提供定位上下文 */
}

::v-deep .el-menu {
  background-image: linear-gradient(rgb(0, 21, 41), rgb(0, 21, 41)) !important;
}

/* hover 时背景微亮但文字仍为白色 */
.sidebar-menu .el-menu-item:hover,
::v-deep .sidebar-menu .el-submenu__title:hover {
  background: linear-gradient(90deg, rgba(255, 255, 255, 0.28) 0%, rgba(255, 255, 255, 0) 100%) !important;
  color: #ffffff !important;
}

::v-deep .el-submenu__title {
  color: #fff !important;
}

/* 激活态：左侧显色条 + 文字白色 */
.sidebar-menu .el-menu-item.is-active {
  background: rgba(64, 158, 255, 0.06);
  color: #ffffff !important;
}

.sidebar-menu .el-menu-item.is-active::before {
  content: '';
  position: absolute;
  left: 6px;
  top: 8px;
  bottom: 8px;
  width: 4px;
  background: #409EFF;
  border-radius: 2px;
}

/* 激活时图标颜色保持白色 */
.sidebar-menu .el-menu-item.is-active i {
  color: #ffffff;
}

/* 图标样式 */
.sidebar-menu .el-submenu__title i,
.sidebar-menu .el-menu-item i {
  color: #ffffff;
  margin-right: 12px;
  font-size: 16px;
  transition: color 0.18s;
}

/* 子菜单箭头颜色 */
.sidebar-menu .el-submenu__icon-arrow {
  color: #ffffff;
  transition: all 0.18s;
}

/* 子菜单样式：缩进、低对比背景 */
.sidebar-menu .el-submenu .el-menu {
  background: rgba(255, 255, 255, 0.01);
  border-right: none;
}

.sidebar-menu .el-submenu .el-menu-item {
  padding-left: 48px !important;
  font-size: 13px;
  height: 44px;
  line-height: 44px;
}

.sidebar-menu .el-submenu .el-menu-item:hover {
  background: rgba(255, 255, 255, 0.02);
  color: #ffffff;
}

/* 折叠状态下让图标居中 */
.sidebar-menu.el-menu--collapse .el-menu-item,
.sidebar-menu.el-menu--collapse .el-submenu__title {
  padding-left: 0 !important;
  display: flex;
  justify-content: center;
  align-items: center;
}

.sidebar-menu.el-menu--collapse .el-menu-item i,
.sidebar-menu.el-menu--collapse .el-submenu__title i {
  margin-right: 0;
}

/* 折叠时隐藏伪元素高亮（避免错位） */
.sidebar-menu.el-menu--collapse .el-menu-item.is-active::before {
  display: none;
}

/* 折叠按钮 */
.collapse-btn {
  position: absolute;
  right: -12px;
  top: 50%;
  transform: translateY(-50%);
  width: 24px;
  height: 40px;
  background: linear-gradient(90deg, #2c3e50, #34495e);
  border-radius: 0 4px 4px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 2px 0 8px rgba(0, 0, 0, 0.2);
  transition: all 0.3s;
}

.collapse-btn:hover {
  background: linear-gradient(90deg, #34495e, #3498db);
  box-shadow: 2px 0 12px rgba(0, 0, 0, 0.3);
}

.collapse-btn i {
  color: #ffffff;
  font-size: 14px;
  transition: transform 0.3s;
}

.collapse-btn:hover i {
  transform: scale(1.1);
}

/* 移动设备适配 */
@media (max-width: 768px) {
  .sidebar-container {
    position: fixed;
    left: 0;
    top: 0;
    width: 280px !important;
    height: 100vh;
    transform: translateX(-100%);
    transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    overflow-x: hidden;
    box-shadow: 4px 0 16px rgba(0, 0, 0, 0.3);
    z-index: 1000;
  }

  .sidebar-container.show {
    transform: translateX(0);
  }

  .collapse-btn {
    display: none;
  }
}

/* 遮罩层 */
.sidebar-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 999;
  transition: opacity 0.3s;
}

.sidebar-overlay.hidden {
  opacity: 0;
  pointer-events: none;
}
</style>